import * as React from 'react';

export const CordedLeft: Function = (
  props: React.SVGProps<SVGSVGElement>,
): JSX.Element => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      role="presentation"
      viewBox="0 0 101.81 63.58"
      {...props}
    >
      <g id="Group_75" data-name="Group 75">
        <g id="Group_37" data-name="Group 37">
          <g id="Group_615" data-name="Group 615">
            <rect
              id="Rectangle_111"
              data-name="Rectangle 111"
              fill="#fff"
              x="10.87"
              y="2.35"
              width="85.71"
              height="60.66"
            />
            <path
              id="Path_2469"
              data-name="Path 2469"
              fill="#dcd9d5"
              d="M96.59,63.58H10.87a.57.57,0,0,1-.56-.57V2.35a.57.57,0,0,1,.56-.57H96.59a.58.58,0,0,1,.57.57h0V63A.58.58,0,0,1,96.59,63.58ZM11.44,62.44H96V2.92H11.44Z"
            />
          </g>
          <g id="Group_616" data-name="Group 616">
            <rect
              id="Rectangle_112"
              data-name="Rectangle 112"
              fill="#fff"
              x="10.87"
              y="2.35"
              width="85.71"
              height="60.66"
            />
            <path
              id="Path_2470"
              data-name="Path 2470"
              fill="#dcd9d5"
              d="M96.59,63.58H10.87a.57.57,0,0,1-.56-.57V2.35a.57.57,0,0,1,.56-.57H96.59a.58.58,0,0,1,.57.57h0V63A.58.58,0,0,1,96.59,63.58ZM11.44,62.44H96V2.92H11.44Z"
            />
          </g>
          <g id="Group_617" data-name="Group 617">
            <rect
              id="Rectangle_113"
              data-name="Rectangle 113"
              fill="#dcd9d5"
              x="16.78"
              y="6.47"
              width="77.71"
              height="52.66"
            />
            <path
              id="Path_2471"
              data-name="Path 2471"
              fill="#dcd9d5"
              d="M92.59,59.58H14.87a.57.57,0,0,1-.56-.57V6.35a.57.57,0,0,1,.56-.57H92.59a.58.58,0,0,1,.57.57h0V59A.58.58,0,0,1,92.59,59.58ZM15.44,58.44H92V6.92H15.44Z"
            />
          </g>
          <path
            id="Path_2472"
            data-name="Path 2472"
            fill="#dcd9d5"
            d="M100.91,63.54H6.55A.53.53,0,0,1,6,63H6a.54.54,0,0,1,.53-.54h94.36a.54.54,0,0,1,.54.54h0A.54.54,0,0,1,100.91,63.54Z"
          />
        </g>
      </g>
      <rect fill="#27375f" x="5.73" y="0.26" width="95.66" height="3.74" />
      <path
        fill="#fff"
        d="M101.13.52V3.74H6V.52h95.14m.52-.52H5.47V4.26h96.18V0Z"
      />
      <rect fill="#27375f" x="5.81" y="37.67" width="95.82" height="1.98" />
      <path
        fill="#fff"
        d="M101.45,37.86v1.61H6V37.86h95.46m.36-.37H5.62v2.35h96.19V37.49Z"
      />
      <polygon
        fill="#27375f"
        points="6.31 13.98 7.1 10.9 101.07 10.9 99.6 13.98 6.31 13.98"
      />
      <path
        fill="#fff"
        d="M100.66,11.15l-1.23,2.57H6.64l.66-2.57h93.36m.82-.51H6.9L6.8,11l-.66,2.57L6,14.24H99.76l.14-.3,1.23-2.57.35-.73Z"
      />
      <polygon
        fill="#27375f"
        points="7.1 17.44 6.31 14.35 99.6 14.35 101.07 17.44 7.1 17.44"
      />
      <path
        fill="#fff"
        d="M99.43,14.61l1.23,2.57H7.3l-.66-2.57H99.43m.33-.51H6l.16.64.66,2.57.1.38h94.58l-.35-.73L99.9,14.39l-.14-.29Z"
      />
      <polygon
        fill="#27375f"
        points="6.31 7.3 7.1 4.22 101.07 4.22 99.6 7.3 6.31 7.3"
      />
      <path
        fill="#fff"
        d="M100.66,4.48,99.43,7.05H6.64L7.3,4.48h93.36m.82-.52H6.9l-.1.39L6.14,6.92,6,7.56H99.76l.14-.29,1.23-2.57.35-.74Z"
      />
      <polygon
        fill="#27375f"
        points="7.1 10.76 6.31 7.68 99.6 7.68 101.07 10.76 7.1 10.76"
      />
      <path
        fill="#fff"
        d="M99.43,7.93l1.23,2.57H7.3L6.64,7.93H99.43m.33-.51H6l.16.64.66,2.57.1.39h94.58l-.35-.74L99.9,7.71l-.14-.29Z"
      />
      <polygon
        fill="#27375f"
        points="6.31 20.66 7.1 17.57 101.07 17.57 99.6 20.66 6.31 20.66"
      />
      <path
        fill="#fff"
        d="M100.66,17.83,99.43,20.4H6.64l.66-2.57h93.36m.82-.51H6.9l-.1.38-.66,2.57L6,20.91H99.76l.14-.29,1.23-2.57.35-.73Z"
      />
      <polygon
        fill="#27375f"
        points="7.1 24.11 6.31 21.03 99.6 21.03 101.07 24.11 7.1 24.11"
      />
      <path
        fill="#fff"
        d="M99.43,21.29l1.23,2.57H7.3l-.66-2.57H99.43m.33-.52H6l.16.64L6.8,24l.1.39h94.58l-.35-.73L99.9,21.06l-.14-.29Z"
      />
      <polygon
        fill="#27375f"
        points="6.31 27.33 7.1 24.25 101.07 24.25 99.6 27.33 6.31 27.33"
      />
      <path
        fill="#fff"
        d="M100.66,24.5l-1.23,2.57H6.64L7.3,24.5h93.36m.82-.51H6.9l-.1.39L6.14,27,6,27.59H99.76l.14-.29,1.23-2.57.35-.74Z"
      />
      <polygon
        fill="#27375f"
        points="7.1 30.79 6.31 27.7 99.6 27.7 101.07 30.79 7.1 30.79"
      />
      <path
        fill="#fff"
        d="M99.43,28l1.23,2.57H7.3L6.64,28H99.43m.33-.51H6l.16.64.66,2.57.1.39h94.58l-.35-.74L99.9,27.74l-.14-.29Z"
      />
      <polygon
        fill="#27375f"
        points="6.31 34.01 7.1 30.92 101.07 30.92 99.6 34.01 6.31 34.01"
      />
      <path
        fill="#fff"
        d="M100.66,31.18l-1.23,2.57H6.64l.66-2.57h93.36m.82-.51H6.9l-.1.38-.66,2.57L6,34.26H99.76L99.9,34l1.23-2.57.35-.73Z"
      />
      <polygon
        fill="#27375f"
        points="7.1 37.47 6.31 34.38 99.6 34.38 101.07 37.47 7.1 37.47"
      />
      <path
        fill="#fff"
        d="M99.43,34.64l1.23,2.57H7.3l-.66-2.57H99.43m.33-.51H6l.16.64.66,2.57.1.38h94.58l-.35-.73L99.9,34.42l-.14-.29Z"
      />
      <circle
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="#27375f"
        fill="#fff"
        cx="16.57"
        cy="38.42"
        r="16.07"
      />
      <rect
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="#fff"
        strokeWidth="0.48px"
        fill="#27375f"
        x="12.68"
        y="3.83"
        width="1.56"
        height="27.02"
      />
      <rect
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="#27375f"
        stroke="#fff"
        strokeWidth="0.59px"
        x="18.14"
        y="3.83"
        width="1.56"
        height="40.29"
      />
      <path
        fill="#27375f"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeWidth="0.4px"
        d="M13.07,26.64h.77A2.11,2.11,0,0,1,16,28.75v8.57a0,0,0,0,1,0,0H11a0,0,0,0,1,0,0V28.75A2.11,2.11,0,0,1,13.07,26.64Z"
      />
      <path
        fill="#27375f"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeWidth="0.4px"
        d="M18.54,38.89h.77A2.11,2.11,0,0,1,21.42,41v8.57a0,0,0,0,1,0,0h-5a0,0,0,0,1,0,0V41a2.11,2.11,0,0,1,2.11-2.11Z"
      />
    </svg>
  );
};
